<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <v-card height="100%">
            <v-toolbar dark color="blue">
                <v-toolbar-title>Documento</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="show = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <iframe :src="ruta" width="100%" :height="height" :name="iframeName"></iframe>
        </v-card>
    </v-dialog>
</template>

<script>
import pdf from "vue-pdf";

export default {
    data: (vm) => ({
        extension: ".pdf",
        ruta: "",
        height: "100%",
    }),

    props: ["visible", "codigo", "rutadoc"],

    computed: {
        show: {
            get() {


                console.log(this.codigo)
                this.ruta =
                    `https://api.icssa.com.ar/SGI/Requisitos/${this.rutadoc}/${this.codigo}.pdf?${Math.random()}`;
                // this.createIframe();

                return this.visible;
            },
            set(value) {
                if (!value) {
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
        iframeName() {
            return `iframe-${this.codigo}`;
        }
    },
    methods: {
        createIframe() {
            const container = document.getElementById('iframe');
            if (container) {
                console.dir(container);
                const iframe = document.createElement('iframe');
                iframe.setAttribute('src', this.ruta);
                iframe.setAttribute('width', '100%');
                container.appendChild(iframe);
            }
        }
    },
    beforeDestroy() {
        this.ruta = null;
    }
};
</script>
